export default "__VITE_ASSET__5IGUHmvi__"